/* ============================================================================
   ICP — SlideCart-by-AMP CRO-overrides — Mexie-Mode — thema "CRO 6-07" (JS)
   Run: op-2026-07-06-008 (iteratie op op-2026-07-06-007) · bron: 7 slide-
   cart-CRO-punten van Sherwin (Marketing Storm) + 5 fixes uit de visuele
   check van de owner (6 juli 2026) + een design-polish-ronde (owner:
   "rustiger, geen afleiding/twijfel; oog naar Afrekenen", 6 juli 2026).
   ----------------------------------------------------------------------------
   PER ITEM TERUGDRAAIEN: zet de betreffende constante in ICP_CRO_CONFIG
   hieronder op false. Alles uit: verwijder de twee "ICP slidecart CRO"-
   includes in layout/theme.liquid.
   Run-007: de Aan/Uit-indicatie op de verzekerde-verzending-switch (fix 1 /
   item 4) is VERWIJDERD. Dit script raakt de verzekerde-verzending-toggle
   nergens meer aan — niet lezen en niet schrijven. De verzekering is opt-in
   (app-default UIT; het icp_sp_optout-script in layout/theme.liquid is in
   run-007 verwijderd).
   Run-008 (design-polish): 3 NIEUWE gates in ICP_CRO_CONFIG (alle default aan,
   elk apart uitzetbaar) — compactProtection + tidyDiscounts + footerTypography;
   die drie zijn puur CSS (alleen de <html>-klasse zetten). De enige JS-
   gedragswijziging is dat de "Gratis verzending"-notitie nu DIRECT NA de
   subtotaal-/Totaal-rij wordt geplaatst i.p.v. ervoor, en zichzelf op die
   positie corrigeert (re-assert bij elk SLIDECART_*-event + observer-pass).
   Geldbedragen worden geformatteerd met het geldformat van de shop zelf
   (window.SLIDECART_FORMAT, door SlideCart op window gezet); ontbreekt dat,
   dan Intl.NumberFormat met de valutacode uit /cart.js (cart.currency).
   Nooit een symbool of valutacode die WIJ hardcoden.
   ============================================================================ */
(function () {
  'use strict';

  /* --------------------- CONFIG: 1 constante per CRO-item ------------------ */
  var ICP_CRO_CONFIG = {
    hideTopBanner:     true,  /* Item 1  - top-banner (promobalk) in de cart verbergen [CSS] */
    totalLabel:        true,  /* Item 2  - "TOTAALBEDRAG" -> vetgedrukt "Totaal" [CSS+JS] */
    savingsLine:       true,  /* Fix 3   - doorgestreepte vergelijkprijs voor het te betalen totaal [CSS+JS] */
    lighterBody:       true,  /* Item 5  - lichtere grijze cart-achtergrond [CSS] */
    cleanPayIcons:     true,  /* Fix 2   - ingebakken SVG-rand om betaaliconen verbergen [CSS] */
    freeShipping:      true,  /* Fix 5   - "Gratis verzending"-notitie DIRECT NA de Totaal-rij [CSS+JS] */
    headerGapFix:      true,  /* Fix 4   - witruimte header -> eerste product verkleinen [CSS] */
    compactProtection: true,  /* Run-008 A - verzekerde-verzending-rij de-benadrukken [CSS] */
    tidyDiscounts:     true,  /* Run-008 B - verwijder-knop op de kortings-chip verbergen [CSS] */
    footerTypography:  true   /* Run-008 C - rustig, consistent typografisch ritme in de footer [CSS] */
  };

  var TXT = {
    totalFrom:    /^\s*totaalbedrag\s*:?\s*$/i, /* het te vervangen label */
    totalTo:      'Totaal',
    freeShipping: 'Gratis verzending' /* het groene vinkje komt uit de CSS (::before) */
  };

  /* CSS-gates op <html>; elke gate hoort bij exact een CRO-item (zie de CSS) */
  var GATES = {
    hideTopBanner:     'icp-cro-banner-off',
    totalLabel:        'icp-cro-total-label',
    savingsLine:       'icp-cro-savings',
    lighterBody:       'icp-cro-bg',
    cleanPayIcons:     'icp-cro-payicons',
    freeShipping:      'icp-cro-freeship',
    headerGapFix:      'icp-cro-header-gap',
    compactProtection: 'icp-cro-compact-sp',
    tidyDiscounts:     'icp-cro-tidy-discounts',
    footerTypography:  'icp-cro-footer-type'
  };
  Object.keys(GATES).forEach(function (key) {
    if (ICP_CRO_CONFIG[key]) { document.documentElement.classList.add(GATES[key]); }
  });

  function cartRoot() { return document.getElementById('slidecarthq'); }

  /* --------------------- Item 2: label-swap -------------------------------- */
  function swapTotalLabel() {
    if (!ICP_CRO_CONFIG.totalLabel) { return; }
    var root = cartRoot(); if (!root) { return; }
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (TXT.totalFrom.test(node.nodeValue)) {
        node.nodeValue = TXT.totalTo;
        if (node.parentElement) { node.parentElement.classList.add('icp-cro-total-label-el'); }
      }
    }
  }

  /* --------------------- geld formatteren (fix 3) --------------------------
     1) het geldformat van de shop zelf (window.SLIDECART_FORMAT, een Shopify-
        money-format-string met {{amount…}}-placeholders — het valutasymbool
        zit in die string van de shop, niet in dit script);
     2) anders Intl.NumberFormat met de valutacode uit /cart.js.
     Nooit een symbool of valutacode die wij hardcoden. */
  function groupDigits(value, decimals, thousands, decimalSep) {
    var parts = value.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return (parts.length > 1) ? parts[0] + decimalSep + parts[1] : parts[0];
  }
  function formatMoney(cents, currencyCode) {
    var fmt = window.SLIDECART_FORMAT;
    if (typeof fmt === 'string' && fmt.indexOf('{{') !== -1) {
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (all, key) {
        var v = cents / 100;
        switch (key) {
          case 'amount':                                  return groupDigits(v, 2, ',', '.');
          case 'amount_no_decimals':                      return groupDigits(v, 0, ',', '.');
          case 'amount_with_comma_separator':             return groupDigits(v, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return groupDigits(v, 0, '.', ',');
          case 'amount_with_apostrophe_separator':        return groupDigits(v, 2, "'", '.');
          default:                                        return groupDigits(v, 2, '.', ',');
        }
      });
    }
    try {
      var locale = document.documentElement.lang || 'nl';
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currencyCode }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currencyCode;
    }
  }

  /* --------------------- Fix 3: doorgestreepte vergelijkprijs --------------
     Compare-at-totaal berekend uit /cart.js + /products/<handle>.js en
     geinjecteerd als <s class="icp-cro-compare-total"> IN
     span.footer-subtotal-prices, direct VOOR strong.slidecart-subtotal.
     Het element wordt VERWIJDERD zodra het compare-at-totaal niet hoger is
     dan het te betalen totaal (cart.total_price). Vervangt de aparte
     "Je bespaart"-regel uit run-005. */
  var productCache = {};   /* handle -> Promise<product-JSON|null> */
  var compareBusy = false;
  var lastCompareKey = '';

  function fetchJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) { throw new Error('HTTP ' + res.status + ' voor ' + url); }
      return res.json();
    });
  }

  function refreshCompareTotal() {
    if (!ICP_CRO_CONFIG.savingsLine || compareBusy) { return; }
    if (!cartRoot()) { return; }
    compareBusy = true;
    fetchJSON('/cart.js').then(function (cart) {
      var items = cart.items || [];
      var handles = [];
      items.forEach(function (it) {
        if (it.handle && handles.indexOf(it.handle) === -1) { handles.push(it.handle); }
      });
      var jobs = handles.map(function (handle) {
        if (!productCache[handle]) {
          productCache[handle] = fetchJSON('/products/' + handle + '.js').catch(function () { return null; });
        }
        return productCache[handle];
      });
      return Promise.all(jobs).then(function (products) {
        var compareAt = {}; /* variant-id -> compare_at_price in centen */
        products.forEach(function (p) {
          if (p && p.variants) {
            p.variants.forEach(function (v) {
              if (v.compare_at_price) { compareAt[v.id] = v.compare_at_price; }
            });
          }
        });
        var compareCents = 0;
        items.forEach(function (it) {
          var unit = (typeof it.final_price === 'number') ? it.final_price : it.price;
          var ca = compareAt[it.variant_id];
          compareCents += ((ca && ca > unit) ? ca : unit) * it.quantity;
        });
        renderCompareTotal(compareCents, cart.total_price, cart.currency);
      });
    }).catch(function () { /* stil falen: de cart blijft gewoon werken */ })
      .then(function () { compareBusy = false; });
  }

  function renderCompareTotal(compareCents, payableCents, currencyCode) {
    var root = cartRoot(); if (!root) { return; }
    var prices = root.querySelector('.footer-subtotal-prices'); if (!prices) { return; }
    var el = prices.querySelector('.icp-cro-compare-total');
    if (!(compareCents > payableCents)) {
      if (el && el.parentNode) { el.parentNode.removeChild(el); }
      lastCompareKey = '';
      return;
    }
    var key = compareCents + '|' + payableCents + '|' + currencyCode;
    if (el && key === lastCompareKey) { return; }
    lastCompareKey = key;
    if (!el) {
      el = document.createElement('s');
      el.className = 'icp-cro-compare-total';
      el.setAttribute('aria-hidden', 'true');
      prices.insertBefore(el, prices.querySelector('.slidecart-subtotal') || prices.firstChild);
    }
    el.textContent = formatMoney(compareCents, currencyCode);
  }

  /* --------------------- Fix 5: gratis-verzending-notitie ------------------
     div.footer-row.icp-cro-free-shipping in footer.footer, DIRECT NA de
     subtotaalregel (div.footer-row.amp-sc__footer-row--subtotal) — het leest
     zo als een voetnoot ONDER Totaal. Fallbacks als de subtotaalrij (nog) niet
     bestaat: vlak VOOR de checkout-knop (form#slidecart-checkout-form); laatste
     redmiddel: onderaan de footer. Zelfcorrigerend: staat het element er wel
     maar NIET direct na de subtotaalrij, dan wordt het teruggezet (re-assert
     bij elke apply() = elk SLIDECART_*-event + elke observer-pass). Idempotent
     op zijn class. Het groene vinkje komt uit de CSS (::before). */
  function ensureFreeShipping() {
    if (!ICP_CRO_CONFIG.freeShipping) { return; }
    var root = cartRoot(); if (!root) { return; }
    var subtotalRow = root.querySelector('.footer-row.amp-sc__footer-row--subtotal');
    var footer = root.querySelector('footer.footer') || root.querySelector('.footer');
    var checkoutForm = root.querySelector('#slidecart-checkout-form');
    var line = root.querySelector('.icp-cro-free-shipping');

    /* Doelplek bepalen: direct NA de subtotaalrij; anders vlak VOOR de
       checkout-knop; anders onderaan de footer. */
    function placeAtTarget(el) {
      if (subtotalRow) {
        subtotalRow.insertAdjacentElement('afterend', el);
      } else if (checkoutForm && checkoutForm.parentNode) {
        checkoutForm.parentNode.insertBefore(el, checkoutForm);
      } else if (footer) {
        footer.appendChild(el);
      }
    }

    if (!subtotalRow && !footer && !checkoutForm) { return; }

    if (line) {
      /* Al aanwezig -> alleen herpositioneren als het niet direct na de
         subtotaalrij staat (self-correct na een app-re-render). */
      if (subtotalRow && line.previousElementSibling !== subtotalRow) {
        placeAtTarget(line);
      }
      return;
    }

    line = document.createElement('div');
    line.className = 'footer-row icp-cro-free-shipping';
    line.textContent = TXT.freeShipping;
    placeAtTarget(line);
  }

  /* --------------------- orkestratie --------------------------------------- */
  var pending = false;
  function applySoon() {
    if (pending) { return; }
    pending = true;
    setTimeout(function () { pending = false; apply(); }, 150);
  }
  function apply() {
    if (!cartRoot()) { return; }
    swapTotalLabel();       /* idempotent */
    ensureFreeShipping();   /* idempotent + zelfcorrigerend op positie */
    refreshCompareTotal();  /* rendert alleen bij een gewijzigd bedrag */
  }

  /* Fix 5 (timing): de drawer is een client-side React-app (div#slidecarthq
     wordt bij boot aan <body> gehangen; re-renders kunnen geinjecteerde
     nodes wissen OF verplaatsen). Drie sporen tegelijk, alle injecties
     idempotent en positie-zelfcorrigerend:
     1) de window-EVENTS SLIDECART_LOADED / SLIDECART_UPDATED /
        SLIDECART_OPENED (bevestigd in de live-DOM-recon van 6 juli 2026);
     2) de gelijknamige window-CALLBACKS (het run-005-mechanisme; blijft
        behouden en roept een eventueel eerder gezette handler netjes aan);
     3) een MutationObserver op <body>. */
  ['SLIDECART_LOADED', 'SLIDECART_UPDATED', 'SLIDECART_OPENED'].forEach(function (name) {
    window.addEventListener(name, applySoon);
    var prev = window[name];
    window[name] = function () {
      if (typeof prev === 'function') { try { prev.apply(this, arguments); } catch (e) {} }
      applySoon();
    };
  });

  function start() {
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t && t.nodeType === 1 && t.closest &&
              t.closest('.icp-cro-compare-total, .icp-cro-free-shipping')) { continue; }
          applySoon();
          return;
        }
      }).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    applySoon();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
